import i18n from '@/i18n/index.js'

export const fetchApi = async (endpoint) => {
  const response = await fetch(
    `${import.meta.env.VITE_APP_API_URL}/${endpoint}?lang=${i18n.global.locale.value}`,
  )
  if (!response.ok) throw new Error(`Failed to fetch ${endpoint}`)
  return await response.json()
}
